export default __webpack_public_path__ + "static/media/placementrefsidebar.012e756a.svg";